import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import inputAndSolutionElement from '../components/inputAndSolution/inputAndSolutionElement.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'FindDesignView',
  setup(__props) {

// Components

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(inputAndSolutionElement)
  ]))
}
}

})